(() => {
  if (window.cvCarouselInit) return;
  window.cvCarouselInit = true;

  const ROOT = '[data-cv-carousel]';
  const TRACK = '[data-cv-carousel-track]';

    const syncArrows = (track) => {
    const root = track.closest(ROOT);
    if (!root) return;

    const prev = root.querySelector('[data-cv-carousel-prev]');
    const next = root.querySelector('[data-cv-carousel-next]');
    const scrollable = track.scrollWidth - track.clientWidth > 1;
    const max = track.scrollWidth - track.clientWidth;

    for (const button of [prev, next]) {
      if (button) button.hidden = !scrollable;
    }
    if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 1);
    if (next) next.toggleAttribute('disabled', track.scrollLeft >= max - 1);
  };

  const bind = () => {
    for (const track of document.querySelectorAll(TRACK)) {
      if (track.dataset.cvBound) continue;
      track.dataset.cvBound = 'true';

      syncArrows(track);
      track.addEventListener('scroll', () => syncArrows(track), { passive: true });
      window.addEventListener('resize', () => syncArrows(track));

      // La largeur des cartes dépend d'images en chargement différé : on
      // recalcule quand la mise en page se stabilise.
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => syncArrows(track)).observe(track);
      }
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cv-carousel-prev], [data-cv-carousel-next]');
    if (!button) return;

    const track = button.closest(ROOT)?.querySelector(TRACK);
    const item = track?.firstElementChild;
    if (!track || !item) return;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const direction = button.hasAttribute('data-cv-carousel-next') ? 1 : -1;

    track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
